import React from "react";

const vesselCallRoutes = [
    {
        path: "/applications/vesselCall/list",
        component: React.lazy(() => import("./VesselCallList")),
    },
    {
        path: "/applications/vesselCall/:viewType/:vcAppId",
        component: React.lazy(() => import("./VesselCallFormDetails")),
    },
];

export default vesselCallRoutes;